export default {"src":"/_next/static/media/starPattern.3c9d39a0.svg","height":230,"width":240,"blurWidth":0,"blurHeight":0};